module.exports = __webpack_public_path__ + "img/sass.24726078.webp";